import React from 'react';
import Particle from '../../Particle';
import { Container, Button } from "react-bootstrap";
import './ComingSoon.css';
import { motion } from "framer-motion";

export default function ComingSoon() {
    return (
        <section className="diwali-launch-page">
            {/* Background particles */}
            <Particle />
            
            {/* Diya decorations around the edges */}
            <div className="diwali-decorations">
                {/* Animated diyas */}
                <motion.div 
                    className="diya"
                    style={{left: '5%', top: '10%'}}
                    animate={{
                        scale: [1, 1.1, 1],
                        opacity: [0.8, 1, 0.8]
                    }}
                    transition={{
                        duration: 3,
                        repeat: Infinity,
                        ease: "easeInOut"
                    }}
                >
                    <lottie-player
                        src="https://assets9.lottiefiles.com/packages/lf20_2znx5lra.json"
                        background="transparent"
                        speed="0.8"
                        style={{width: '100px', height: '100px'}}
                        loop
                        autoplay
                    />
                </motion.div>
                
                <motion.div 
                    className="diya"
                    style={{right: '5%', top: '15%'}}
                    animate={{
                        scale: [1, 1.2, 1],
                        opacity: [0.7, 1, 0.7]
                    }}
                    transition={{
                        duration: 4,
                        repeat: Infinity,
                        ease: "easeInOut",
                        delay: 0.5
                    }}
                >
                    <lottie-player
                        src="https://assets9.lottiefiles.com/packages/lf20_2znx5lra.json"
                        background="transparent"
                        speed="1"
                        style={{width: '120px', height: '120px'}}
                        loop
                        autoplay
                    />
                </motion.div>
                
                <motion.div 
                    className="diya"
                    style={{left: '10%', bottom: '15%'}}
                    animate={{
                        scale: [1, 1.15, 1],
                        opacity: [0.9, 1, 0.9]
                    }}
                    transition={{
                        duration: 3.5,
                        repeat: Infinity,
                        ease: "easeInOut",
                        delay: 0.8
                    }}
                >
                    <lottie-player
                        src="https://assets9.lottiefiles.com/packages/lf20_2znx5lra.json"
                        background="transparent"
                        speed="0.9"
                        style={{width: '150px', height: '150px'}}
                        loop
                        autoplay
                    />
                </motion.div>
                
                <motion.div 
                    className="diya"
                    style={{right: '10%', bottom: '10%'}}
                    animate={{
                        scale: [1, 1.25, 1],
                        opacity: [0.8, 1, 0.8]
                    }}
                    transition={{
                        duration: 4.5,
                        repeat: Infinity,
                        ease: "easeInOut",
                        delay: 0.3
                    }}
                >
                    <lottie-player
                        src="https://assets9.lottiefiles.com/packages/lf20_2znx5lra.json"
                        background="transparent"
                        speed="1.1"
                        style={{width: '90px', height: '90px'}}
                        loop
                        autoplay
                    />
                </motion.div>
            </div>
            
            {/* Firework explosions */}
            <div className="firework-animations">
                <lottie-player
                    src="https://assets1.lottiefiles.com/packages/lf20_obhph3sh.json"
                    background="transparent"
                    speed="0.8"
                    style={{width: '200px', height: '200px', position: 'absolute', top: '5%', left: '15%'}}
                    loop
                    autoplay
                />
                <lottie-player
                    src="https://assets1.lottiefiles.com/packages/lf20_obhph3sh.json"
                    background="transparent"
                    speed="1"
                    style={{width: '250px', height: '250px', position: 'absolute', top: '10%', right: '10%'}}
                    loop
                    autoplay
                />
                <lottie-player
                    src="https://assets1.lottiefiles.com/packages/lf20_obhph3sh.json"
                    background="transparent"
                    speed="0.9"
                    style={{width: '300px', height: '300px', position: 'absolute', bottom: '5%', left: '20%'}}
                    loop
                    autoplay
                />
                <lottie-player
                    src="https://assets1.lottiefiles.com/packages/lf20_obhph3sh.json"
                    background="transparent"
                    speed="1.1"
                    style={{width: '220px', height: '220px', position: 'absolute', bottom: '15%', right: '15%'}}
                    loop
                    autoplay
                />
                
                {/* Additional smaller fireworks */}
                {[...Array(8)].map((_, i) => (
                    <lottie-player
                        key={i}
                        src="https://assets1.lottiefiles.com/packages/lf20_obhph3sh.json"
                        background="transparent"
                        speed={0.7 + Math.random() * 0.6}
                        style={{
                            width: `${100 + Math.random() * 100}px`,
                            height: `${100 + Math.random() * 100}px`,
                            position: 'absolute',
                            top: `${5 + Math.random() * 80}%`,
                            left: `${5 + Math.random() * 80}%`,
                            opacity: 0.6
                        }}
                        loop
                        autoplay
                    />
                ))}
            </div>
            
            {/* Floating lanterns */}
            <div className="lantern-animations">
                {[...Array(5)].map((_, i) => (
                    <motion.div
                        key={i}
                        initial={{ y: 100, opacity: 0 }}
                        animate={{ 
                            y: -window.innerHeight,
                            opacity: [0, 1, 0],
                            x: [0, Math.random() * 100 - 50, 0]
                        }}
                        transition={{
                            duration: 15 + Math.random() * 10,
                            repeat: Infinity,
                            delay: Math.random() * 5,
                            ease: "linear"
                        }}
                        style={{
                            position: 'absolute',
                            left: `${10 + Math.random() * 80}%`,
                            bottom: '-100px'
                        }}
                    >
                        <lottie-player
                            src="https://assets1.lottiefiles.com/packages/lf20_4XmSkB.json"
                            background="transparent"
                            speed={0.5 + Math.random() * 0.5}
                            style={{
                                width: `${80 + Math.random() * 70}px`,
                                height: `${80 + Math.random() * 70}px`
                            }}
                            loop
                            autoplay
                        />
                    </motion.div>
                ))}
            </div>
            
            {/* Confetti */}
            <div className="confetti-animation">
                <lottie-player
                    src="https://assets1.lottiefiles.com/packages/lf20_6cu2jbdu.json"
                    background="transparent"
                    speed="1"
                    style={{width: '100%', height: '100%', position: 'absolute', top: 0, left: 0}}
                    loop
                    autoplay
                />
            </div>
            
            {/* Main content */}
            <Container fluid className="content-container">
                <motion.div
                    initial={{ scale: 0.8, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    transition={{ duration: 0.8, type: "spring" }}
                >
                    <Container className="main-content text-center">
                        <motion.h1 
                            className="title"
                            animate={{
                                textShadow: [
                                    "0 0 10px #fff, 0 0 20px #fff, 0 0 30px #e60073, 0 0 40px #e60073",
                                    "0 0 10px #fff, 0 0 20px #ff4da6, 0 0 30px #ff4da6, 0 0 40px #ff4da6",
                                    "0 0 10px #fff, 0 0 20px #fff, 0 0 30px #e60073, 0 0 40px #e60073"
                                ]
                            }}
                            transition={{
                                duration: 2,
                                repeat: Infinity,
                                repeatType: "reverse"
                            }}
                        >
                            <motion.span
                                animate={{
                                    color: ["#ffcc00", "#ff6600", "#ffcc00"]
                                }}
                                transition={{
                                    duration: 3,
                                    repeat: Infinity,
                                    repeatType: "reverse"
                                }}
                            >
                                Blog Launched!
                            </motion.span>
                        </motion.h1>
                        
                        <motion.p 
                            className="subtitle"
                            animate={{
                                scale: [1, 1.05, 1],
                                opacity: [0.8, 1, 0.8]
                            }}
                            transition={{
                                duration: 4,
                                repeat: Infinity,
                                ease: "easeInOut"
                            }}
                        >
                            Version 1.68 | My Blog Special Edition
                        </motion.p>
                        
                        <div className="launch-button-container">
                            <motion.div
                                whileHover={{ scale: 1.1 }}
                                whileTap={{ scale: 0.95 }}
                            >
                                <Button 
                                    variant="primary"
                                    className="launch-button"
                                    onClick={() => window.open('https://harishblogie.pythonanywhere.com/', '_blank')}
                                >
                                    <motion.span
                                        animate={{
                                            textShadow: [
                                                "0 0 5px #fff",
                                                "0 0 10px #fff",
                                                "0 0 5px #fff"
                                            ]
                                        }}
                                        transition={{
                                            duration: 1.5,
                                            repeat: Infinity,
                                            repeatType: "reverse"
                                        }}
                                    >
                                        Visit Live Blog
                                    </motion.span>
                                </Button>
                            </motion.div>
                        </div>
                        
                        <motion.div 
                            className="celebrate-text"
                            animate={{
                                scale: [1, 1.2, 1],
                                opacity: [0.7, 1, 0.7]
                            }}
                            transition={{
                                duration: 3,
                                repeat: Infinity,
                                ease: "easeInOut"
                            }}
                        >
                            🎉 Happy Learning! ❤️
                        </motion.div>
                    </Container>
                </motion.div>
            </Container>
        </section>
    );
}